/** 普通用户页面 i18n 扩展（zh-CN） */
export default {
  router: {
    unnamed: '未命名页面',
    login: '登录',
    register: '用户注册',
    forgotPassword: '忘记密码',
    resetPassword: '重置密码',
    activate: '账户激活',
    dashboard: '仪表盘',
    targetDetail: '任务详情',
    targetReportDetail: '靶点报告详情',
    hallucination: '幻觉检测',
    interactiveEdit: '报告交互编辑',
    intelligenceSubscription: '情报订阅',
    intelligenceFeed: '情报更新',
    targetChat: '任务对话',
    targetAnalysisV2: '任务分析',
    quickTools: '快速工具',
    quickToolsCreateTemplate: '新建批量模版',
    quickToolsEditExpert: '编辑专家模版',
    quickToolsEditQuick: '编辑快速模版',
    outlineTemplates: '大纲模版',
    knowledgeMap: '知识地图',
    knowledgeMapSubscription: '知识地图订阅配置',
    knowledgeMapSubscriptionFeed: '知识地图订阅更新',
    knowledgeBase: '知识库',
    userManual: '使用手册',
    profile: '个人信息',
    preferenceStats: '我的使用统计',
    preferenceCenter: '我的偏好画像',
    feedback: '用户反馈',
    account: '账户信息',
    inviteCodeManagement: '邀请码管理',
    rechargeManagement: '充值管理',
    paymentCenter: '充值中心',
    membership: '会员中心',
    notifications: '通知中心'
  },
  onboarding: {
    stepProgress: '第 {current} / {total} 步',
    skip: '跳过',
    next: '下一步',
    finish: '完成',
    steps: {
      modesIntro: { title: '三种对话模式', desc: 'epiXora 提供快速、专家、撰写三种模式，可按任务复杂度自由切换。接下来将逐一介绍各模式能力。' },
      quickMode: { title: '快速模式', desc: '快速拆解主题并生成结构化问题，适合先快速摸清方向与关键事实。' },
      expertMode: { title: '专家模式', desc: '适合深度调研场景，支持更完整的分析流程与报告生成。' },
      writeMode: { title: '撰写模式', desc: '聚焦内容写作与润色，可基于已确认主题快速进入撰写流程。' },
      home: { title: '首页', desc: '用于进入任务分析主工作区，随时可以回到这里开始新的调研任务。' },
      knowledgeBase: { title: '知识库', desc: '集中管理文献与资料。支持文件夹分类、上传 PDF/DOCX、搜索浏览；对话中引用的文件可从此处选择。' },
      knowledgeMap: { title: '知识地图', desc: '将调研结果沉淀为结构化知识网络，便于后续复盘与持续扩展。' },
      quickTools: { title: '快速工具', desc: '创建批量模版针对多主题调研场景进行快速调研，表格化内容呈现帮助更快对比信息。还有模版管理工具内置其中，可通过配置管理内容快速复用，提升重复调研效率。' },
      notifications: { title: '通知中心', desc: '展示任务动态、账户变化与系统功能，方便您及时获知必要信息。' },
      profile: { title: '个人中心', desc: '将提供账号信息、会员订阅及各种帮助反馈入口。' }
    }
  },
  preference: {
    center: {
      title: '我的偏好画像中心',
      wizardTip: '3 步快速完成偏好初始化',
      wizard: '偏好引导',
      statsTip: '查看我的使用统计',
      stats: '使用统计',
      reanalyzeTip: '让 AI 重新分析最近的对话与报告，更新对您的认知',
      reanalyze: '重新分析我的偏好',
      basicProfile: '基础画像',
      unsavedChanges: '未保存的更改',
      save: '保存修改',
      reset: '撤销',
      professionalLevel: '专业水平',
      levelBeginner: '初级',
      levelIntermediate: '中级',
      levelExpert: '专家',
      terminologyLevel: '术语级别',
      termBasic: '基础',
      termProfessional: '专业',
      termAcademic: '学术',
      chatStyle: '聊天风格',
      styleCasual: '轻松',
      styleProfessional: '专业',
      styleAcademic: '学术',
      responseLength: '回复长度',
      lengthConcise: '简洁',
      lengthModerate: '适中',
      lengthDetailed: '详细',
      reportDepth: '报告深度',
      depthBrief: '简要',
      depthStandard: '标准',
      depthDetailed: '详细',
      reportStyle: '报告风格',
      styleTechnical: '技术型',
      styleBusiness: '商业型',
      styleGeneral: '通用型',
      includeReferences: '包含参考文献',
      includeCharts: '包含图表',
      autoLearn: '自动学习偏好',
      autoLearnTip: '关闭后系统将不再从您的对话中自动学习',
      noProfile: '暂无画像数据',
      focusAreas: '关注领域',
      focusAreasTip: '这些标签会在生成报告和回答时优先关注',
      interestedTargets: '感兴趣的靶点',
      addTarget: '添加靶点',
      interestedDiseases: '感兴趣的疾病',
      addDisease: '添加疾病',
      interestedDrugTypes: '感兴趣的药物类型',
      addDrugType: '添加药物类型',
      memories: '我的记忆',
      memoryCount: '{count} 条',
      allTypes: '全部类型',
      addMemory: '新增记忆',
      noMemories: '还没有记忆，可点击「重新分析我的偏好」或手动新增',
      pinned: '已固定',
      unpin: '取消固定',
      pin: '固定（不会被自动清理）',
      deleteMemoryConfirm: '确定删除这条记忆？',
      confidence: '置信度 {value}',
      confidenceLabel: '置信度',
      weight: '权重 {value}',
      usageCount: '使用 {count} 次',
      source: '来源 {value}',
      history: '偏好分析历史',
      historySummary: '分析消息 {chat} 条 · 报告 {reports} 篇 · 反馈 {feedbacks} 条',
      historyMemories: '新建记忆 {created} · 更新 {updated}',
      noHistory: '暂无分析历史',
      aiView: 'AI 眼中的我',
      copyPrompt: '复制提示词',
      tabChat: '问答场景',
      tabReport: '报告生成',
      noContext: '暂无可用上下文，先完善画像或点击重新分析',
      relevantMemories: '参考的相关记忆（Top {count}）',
      wizardWelcome: '欢迎使用，3 步认识您',
      wizardStepBasic: '基础画像',
      wizardStepFocus: '关注领域',
      wizardStepStyle: '风格偏好',
      wizardStep1Desc: '您的专业水平和术语偏好会影响 AI 回答的深度与用词。',
      saved: '偏好已保存',
      saveFailed: '保存失败',
      extractStarted: '已开始重新分析您的偏好',
      extractFailed: '分析失败',
      extractFailedWithReason: '分析失败：{reason}',
      wizardDisease: {
        lung: '肺癌',
        breast: '乳腺癌',
        colorectal: '结直肠癌',
        hematologic: '血液肿瘤',
        autoimmune: '自身免疫病',
        neurodegenerative: '神经退行性疾病',
        metabolic: '代谢疾病'
      },
      wizardDrug: {
        smallMolecule: '小分子',
        monoclonal: '单抗',
        bispecific: '双抗',
        adc: 'ADC',
        protac: 'PROTAC',
        cellTherapy: '细胞疗法',
        geneTherapy: '基因疗法',
        mrna: 'mRNA'
      },
      promptCopied: '提示词已复制',
      maxTags: '最多 {max} 个',
      maxSelect: '最多选择 {max} 个',
      maxTagsKeep: '最多保留 {max} 个标签',
      memoryTypeOutline: '大纲偏好',
      memoryTypeQuestion: '问题模式',
      memoryTypeFocus: '关注领域',
      memoryTypeCommunication: '沟通风格',
      memoryTypeExplicit: '明确偏好',
      memoryTypeNegative: '不喜欢',
      memoryTypeProfessional: '专业档案',
      memoryTypeReport: '报告偏好',
      memoryTypeOther: '其他',
      sourceChat: '对话',
      sourceReport: '报告',
      sourceFeedback: '反馈',
      sourceManual: '手动',
      statusCompleted: '完成',
      statusFailed: '失败',
      statusProcessing: '进行中',
      statusPending: '排队中',
      extractionScheduled: '定时',
      extractionTriggered: '触发',
      extractionManual: '手动',
      wizardLevelBeginner: '入门 · 偏科普',
      wizardLevelIntermediate: '中级 · 平衡',
      wizardLevelExpert: '专家 · 深度',
      wizardStep2Desc: '勾选您关心的方向，AI 会在生成报告和回答时优先涉及；后续可在主页面随时增减。',
      wizardStep3Desc: '最后选一下您喜欢的回答与报告风格。',
      wizardCommonTargets: '常见靶点（多选）',
      wizardDiseaseAreas: '疾病领域（多选）',
      wizardDrugTypes: '药物类型（多选）',
      wizardCustomTargetPlaceholder: '自定义靶点，回车添加',
      wizardCustomDiseasePlaceholder: '自定义疾病，回车添加',
      wizardReferences: '参考文献',
      wizardCharts: '图表说明',
      skipWizard: '下次再说',
      prevStep: '上一步',
      nextStep: '下一步',
      finishAndSave: '完成并保存',
      wizardSaved: '已记住您的偏好，AI 将立即按此风格回答',
      newMemoryDialog: '新增偏好记忆',
      memoryType: '记忆类型',
      memoryKey: '记忆键',
      memoryValue: '记忆值',
      memoryKeyPlaceholder: '例如 prefer_clinical_focus',
      memoryValuePlaceholder: '用一两句话描述这条偏好',
      isPinned: '是否固定',
      isPinnedTip: '固定的记忆不会被自动清理或权重衰减',
      pleaseSelect: '请选择',
      loadProfileFailed: '加载偏好画像失败',
      loadMemoriesFailed: '加载记忆失败',
      saveFailedWithReason: '保存失败：{reason}',
      reanalyzeConfirm: '将基于您最近的对话与报告重新学习偏好，过程可能需要几十秒。是否继续？',
      reanalyzeTitle: '重新分析偏好',
      start: '开始',
      extractComplete: '分析完成：新建 {created} 条 · 更新 {updated} 条',
      extractNotRun: '分析未执行',
      pinnedSuccess: '已固定',
      unpinnedSuccess: '已取消固定',
      deleted: '已删除',
      deleteFailed: '删除失败',
      fillMemoryComplete: '请填写完整的记忆键和值',
      addSuccess: '新增成功',
      addFailedWithReason: '新增失败：{reason}',
      noPromptToCopy: '暂无可复制的提示词',
      copiedToClipboard: '已复制到剪贴板',
      copyFailed: '复制失败，请手动选择'
    },
    stats: {
      title: '我的使用统计',
      gotoCenter: '回到我的偏好画像',
      preferenceCenter: '我的偏好画像',
      range: '统计范围',
      last7: '最近 7 天',
      last30: '最近 30 天',
      last90: '最近 90 天',
      activeHours: '最活跃时段分布',
      basedOnDays: '基于最近 {d} 天',
      noActivity: '暂无活动记录',
      focusCloud: '研究偏好关注云',
      focusCloudTip: '基于功能使用分布与您画像中的关注领域',
      noFocus: '暂无关注偏好数据，可前往「我的偏好画像」完善',
      commonPaths: '常见访问路径',
      path: '访问路径',
      count: '次数',
      noPath: '暂无访问路径',
      debugDetail: '调试详情：原始功能使用分布（API / 按钮）',
      apiTop: 'API 调用频率 Top 10',
      apiName: 'API 名称',
      btnTop: '按钮点击频率 Top 10',
      btnName: '按钮名称',
      noData: '暂无数据',
      avgSession: '平均会话时长',
      pageVisits: '页面访问',
      reports: '报告生成',
      chats: '对话次数',
      loadFailed: '加载统计数据失败'
    }
  },
  profile: {
    myPreferenceCenter: '我的偏好画像'
  },
  registerMarketing: {
    title: '创建您的账户',
    subtitle: '开启您的快速调研之旅',
    heroTitle: '探索您的\n专属\n智能调研智库',
    heroDesc: '全维覆盖靶点调研、竞品动态、技术研发、市场趋势等调研场景，生成定制化报告，突破人工检索与阅读瓶颈。',
    phoneRegistered: '该手机号码已注册，可直接登录'
  },
  activate: {
    title: '账户激活',
    loading: '正在激活您的账户，请稍候...',
    successTitle: '激活成功！',
    successSub: '您的账户已成功激活，现在可以登录使用了',
    goLogin: '前往登录',
    errorTitle: '激活失败',
    errorSub: '激活链接无效或已过期，请联系管理员重新发送激活邮件',
    missingToken: '缺少激活令牌，请检查邮件中的链接是否完整',
    resendEmail: '重新发送激活邮件'
  },
  inviteCode: {
    back: '返回',
    title: '邀请码管理',
    description: '生成专属邀请码，邀请好友注册获得丰厚奖励',
    successInvites: '成功邀请',
    totalRewards: '累计奖励 (X-Coin)',
    pendingRewards: '待发放奖励',
    totalInvites: '总邀请人数',
    myCode: '我的邀请码',
    copyLink: '复制邀请链接',
    codeLabel: '邀请码：',
    linkLabel: '邀请链接：',
    loading: '加载中...',
    scanRegister: '扫码注册',
    shareWechat: '分享到微信',
    wechatShort: '微信',
    copySuccess: '已复制到剪贴板',
    copyFailed: '复制失败'
  },
  rechargePage: {
    back: '返回',
    title: '充值管理',
    description: '充值X-Coin，享受更多服务，首次充值还可获得邀请奖励',
    balanceTitle: '账户余额',
    rechargeNow: '立即充值',
    currentBalance: '当前余额',
    totalRecharged: '累计充值',
    yuan: '元',
    rechargeCount: '充值次数',
    times: '次',
    firstRecharge: '首次充值',
    recordsTitle: '充值记录',
    orderPlaceholder: '订单编号',
    filterStatus: '筛选状态',
    allRecords: '全部记录',
    statusCompleted: '支付成功',
    statusPending: '待支付',
    statusFailed: '支付失败',
    statusCancelled: '已取消',
    query: '查询',
    emptyRecords: '暂无充值记录',
    amount: '充值金额',
    xcoin: '获得X-Coin',
    paymentMethod: '支付方式',
    paymentStatus: '支付状态',
    firstRechargeCol: '首次充值',
    firstBadge: '首充'
  },
  progressChannels: {
    // Loom v2 deep-research channels — schema in
    // frontend/src/utils/deepResearchChannels.js, backend specs in
    // backend/app/workflows/deep_research/progress_channels.py.
    // Backend writes already-localized step_message; these templates serve
    // as locale fallback (e.g. historical rows missing step_message).
    'dr.planning.completed': '调研规划完成',
    'dr.knowledge.search_started': '正在检索: {query}',
    'dr.knowledge.search_completed': '已收集 {total_count} 条数据',
    'dr.knowledge.completed': '数据收集完成',
    'dr.synthesis.toe_started': '正在构建知识图谱',
    'dr.synthesis.toe_stage_completed': '图谱阶段：{stage}',
    'dr.synthesis.toe_completed': '知识图谱构建完成',
    'dr.synthesis.report_started': '开始撰写报告',
    'dr.synthesis.report_outline_written': '大纲：{title}',
    'dr.synthesis.report_section_written': '章节：{section_title}',
    'dr.synthesis.report_abstract_written': '摘要已生成',
    'dr.synthesis.report_conclusion_written': '结论已生成',
    'dr.synthesis.report_completed': '报告撰写完成',
    'dr.run.completed': '报告生成完成',
    'dr.translation.started': '开始翻译',
    'dr.translation.completed': '翻译完成',
    'dr.packaging.completed': '报告打包完成',
    'ts.planning.completed': '调研规划完成',
    'ts.collection.started': '开始数据检索',
    'ts.collection.progress': '数据检索中',
    'ts.collection.completed': '数据检索完成',
    'ts.writing.started': '开始撰写报告',
    'ts.writing.completed': '报告撰写完成',
    'ts.packaging.completed': '报告打包完成',
    'target_survey.workflow.started': '正在启动靶点调研工作流',
    'target_survey.started': '开始靶点调研',
    'target_survey.input': '开始靶点调研',
    'target_survey.research': '靶点证据采集中',
    'target_survey.structured': '结构化证据整理中',
    'target_survey.report': '靶点报告撰写中',
    'target_survey.report.draft': '报告草稿预览更新中',
    'target_survey.quality': '质量校验中',
    'target_survey.completed': '质量校验通过，报告已就绪',
    'target_survey.trace.lane_started': '正在启动多维度调研',
    'target_survey.trace.lane_progress': '调研数据采集中',
    'target_survey.trace.checkpoint_resume': '正在恢复调研进度',
    'target_survey.trace.gap_backfill': '正在补充关键证据',
    'target_survey.trace.synthesis': '正在撰写统一报告',
    'target_survey.trace.quality_check': '正在校验引用与溯源',
    'target_survey.trace.retry': '网络波动，自动重试中',
    'target_survey.trace.hermes': '调研进行中',
    'llm_agent.task.submitted': '撰写任务已提交',
    'llm_agent.task': '远端已接受任务',
    'llm_agent.workflow.started': '开始撰写',
    'llm_agent.tool.dispatched': '撰写进行中',
    'llm_agent.tool.completed': '撰写进行中',
    'llm_agent.workflow.completed': '撰写完成',
    'hermes_writing.started': 'Hermes 自由撰写已启动',
    'hermes_writing.resume': '正在恢复 Hermes 自由撰写',
    'hermes_writing.progress': 'Hermes 调研撰写中',
    'hermes_writing.tool.dispatched': 'Hermes 工具调用',
    'hermes_writing.persist': '正在保存 Hermes 撰写结果',
    'hermes_writing.completed': 'Hermes 自由撰写完成'
  },
  kbFolder: {
    allLibraries: '所有知识库',
    unnamedFolder: '未命名文件夹',
    fileCount: '{count} 个文件',
    collapseInfo: '收起文件信息',
    expandInfo: '展开文件信息',
    fileName: '文件名',
    fileType: '类型',
    fileSize: '大小',
    uploadedAt: '上传时间',
    actions: '操作',
    download: '下载',
    rename: '重命名',
    delete: '删除',
    fileInfo: '文件信息',
    relatedReports: '关联报告',
    completed: '已完成',
    noRelatedReports: '暂无关联报告',
    labelName: '名称',
    labelSize: '大小',
    labelUploader: '上传者',
    emptyFiles: '暂无文件数据',
    notConnected: '暂未接通',
    finishedAt: '完成时间',
    fileContent: '文件内容',
    noContentPreview: '暂无内容预览',
    noFileDetail: '暂无文件详情'
  },
  hallucinationPage: {
    filterAll: '全部',
    filterPending: '待解决',
    filterResolved: '已修复',
    filterDismissed: '误报',
    tagResolved: '已修复',
    tagDismissed: '误报',
    markDismissed: '标记为误报',
    undo: '撤销',
    restore: '恢复',
    dismissConfirm: '确认将该条标记为误报？标记后将从「待解决」列表移除。',
    dismissTitle: '标记误报',
    dismissOk: '确认误报',
    dismissed: '已标记为误报',
    noPending: '暂无待解决的幻觉问题'
  },
  targetReportDetail: {
    archive: {
      archived: '已成功归档到知识库',
      rearchive: '重新归档 / 挂载至其它文件夹',
      saveTitle: '保存至知识库',
      selectFolder: '选择目标知识库文件夹',
      quickSave: '一键保存到知识库',
      createTopic: '快速创建学术研究主题',
      createAndSelect: '创建并选择',
      confirmSave: '确定保存',
      rearchiveTitle: '重新归档'
    }
  },
  reportInteractiveEdit: {
    backToReport: '返回报告',
    title: '交互编辑',
    unsaved: '未保存',
    synced: '已同步',
    layoutAria: '工作区布局',
    stop: '停止',
    traceTip: '执行轨迹（工具调用与计费摘要）',
    trace: '轨迹',
    save: '保存',
    more: '更多',
    undoAi: '撤销 AI 改写',
    redoAi: '重做 AI 改写',
    versionHistory: '版本历史',
    exportMd: '导出 Markdown',
    exportWord: '导出 Word',
    exportPdf: '导出 PDF',
    reload: '重新载入',
    noPermission: '无权限使用交互编辑',
    assistant: '智能助手',
    assistantChatAria: '智能助手对话',
    selectionChars: '选区 {count} 字',
    refreshSelection: '刷新选区',
    showReport: '显示报告',
    collapseReportTip: '收起报告，专注对话',
    quickCommands: '快捷指令',
    quickCommandsHint: '单击填入 · 双击编辑（仅自定义） · 点「+ 自定义」添加',
    clickToFill: '点击填入',
    dblClickToEdit: '点击填入 · 双击编辑',
    delete: '删除',
    custom: '自定义',
    chatHistory: '对话记录',
    messageCount: '{count} 条',
    restoredLocal: '已恢复本机历史',
    restoredServer: '已同步服务端记录',
    exitFullscreen: '退出全屏',
    fullscreenChat: '全屏查看对话',
    fullscreen: '全屏',
    fullscreenView: '全屏查看',
    chatEmptyTitle: '开始与智能助手协作编辑报告',
    quickStart: '快捷开始',
    chatEmptyTip1: '在报告区拖选段落后点「刷新选区」，可将选区随指令发送，适合局部改写。',
    chatEmptyTip2: '{sendShortcut} 发送指令；{saveShortcut} 保存到服务器。',
    chatEmptyTip3: '执行轨迹在右侧抽屉中查看（顶栏「轨迹」或底栏链接）；生成时会自动打开。',
    incomplete: '未完成',
    expand: '展开',
    collapse: '折叠',
    copyPlain: '复制纯文本',
    copy: '复制',
    imageTag: '图 {name}',
    charsClickExpand: '（{count} 字）点击展开',
    writeToSection: '写入报告节',
    copyMarkdown: '复制 Markdown',
    retryTurn: '重试本回合',
    retryTurnHint: '将重新发送相同指令、选区与附件',
    reasoning: '正在推理与调用工具…',
    selectionBannerBefore: '已选',
    selectionBannerAfter: '字，将随下条指令一并发送',
    clear: '清除',
    advancedToolsAttachments: '高级 · 工具范围 / 附件',
    toolScope: '工具范围',
    toolScopeStandard: '推荐（检索+编辑，默认）',
    toolScopeDocumentOnly: '仅改正文（无联网工具）',
    toolScopeFull: '全量工具（含结构库/ADMET）',
    toolScopeHint: '默认已排除易干扰路由的 ADMET/结构库；需要 PDB 等请选全量。',
    bodyAttachments: '正文附件（自动抽取）',
    uploadFile: '上传文件',
    taskFiles: '任务文件',
    knowledgeBase: '知识库',
    cloudFiles: '云盘文件',
    bodyAttachHint: 'PDF/Word/Excel/PPT(.pptx)/HTML/文本等将自动抽取正文；最多 {max} 个。',
    imageAttachments: '插图附件（嵌入报告）',
    uploadImage: '上传插图',
    taskImages: '任务图片',
    cloudImages: '云盘图片',
    imageAttachHint: '发送后由 AI 调用 embed_report_images 插入；也可在右侧报告区「插入图片」直接写入光标处。最多 {max} 张。',
    targetChapters: '目标章节（可选）',
    targetChaptersPlaceholder: '不选则由 AI 自动匹配相关章节',
    targetChaptersHint: '选定后：正文附件优先写入对应章节；插图附件通过 embed_report_images 插入对应标题附近。',
    promptPlaceholder: '描述如何根据附件/选区修改报告，或点快捷指令；可上传 PDF、Word、Excel、文本等供自动解析',
    chatFullscreenPlaceholder: '可直接输入对话内容，Ctrl/Cmd + Enter 发送',
    switchModel: '切换模型：{model}',
    modelGroupSystem: '系统推荐',
    modelGroupTier: '会员档位',
    modelGroupFallback: '其他可用',
    noModelsFallback: '未拉到模型列表，将使用后端默认',
    send: '发送',
    sendCommand: '发送指令',
    sendShortcut: '发送',
    clearChat: '清空对话',
    saveToServer: '保存到服务器',
    saveShortcutBar: '保存',
    splitHandleAria: '拖动调整对话与报告区宽度',
    editorAria: 'Markdown 编辑与预览',
    tabSource: '源码',
    tabSplit: '分栏',
    tabPreview: '预览',
    showChat: '显示对话',
    collapseChatTip: '收起对话，专注报告',
    chapterIndex: '章节索引',
    insertImage: '插入图片',
    insertPendingImages: '插入待附图 {count}',
    syncScroll: '同步滚动',
    charCount: '{count} 字符',
    mdEditorPlaceholder: 'Markdown 正文（可直接编辑）',
    traceLink: '轨迹',
    traceDrawerTitle: '执行轨迹',
    traceDrawerTip: '展示本回合及历史步骤、工具调用与计费摘要；生成中会自动打开此面板。',
    inProgress: '进行中',
    stepCount: '{count} 步',
    copyAll: '复制全部',
    clearTrace: '清空',
    traceEmpty: '发送指令后，将显示步骤、工具与计费摘要',
    backendDuration: '后端真实耗时',
    estimatedDuration: '相邻事件估算耗时',
    toolDataBytes: '本次工具调用数据量',
    taskFilesDialogTitle: '从当前任务选择文件',
    fileName: '文件名',
    attachment: '附件',
    extractable: '可抽取',
    notExtractable: '不可抽取',
    size: '大小',
    status: '状态',
    taskFilesHint: '仅可选择 PDF、Word、Excel、PPT(.pptx)、HTML 或文本类文件；外链、图片、压缩包、老式 .ppt 等不可注入。',
    cancel: '取消',
    addSelected: '添加选中',
    promptEditorLabelPlaceholder: '给指令起个简短标题（≤ 24 字）',
    promptEditorPromptPlaceholder: '指令内容（可粘贴当前输入框内容，≤ 4000 字）',
    promptEditorHint: '提示：本机存储，跨任务复用；同账号其他 tab 会自动同步。',
    msgDetail: '消息详情',
    msgTitleUser: '我的指令',
    msgTitleAssistant: '助手分析结果',
    msgTitleSystem: '系统消息',
    roleMe: '我',
    roleAssistant: '助手',
    roleFusion: '检索融合',
    roleAttachment: '附件注入',
    roleNote: '说明',
    roleSystem: '系统',
    avatarMe: '我',
    avatarAi: 'AI',
    avatarNote: '注',
    avatarSystem: '系',
    emptyContent: '（空内容）',
    versionsDrawerTitle: '报告版本历史',
    versionsTip: '每次手动保存、自动保存或版本回滚都会归档独立副本。可与当前编辑内容对比或一键恢复。',
    viewCompare: '查看对比',
    rollbackConfirm: '恢复后当前未保存修改将丢失，确定继续？',
    rollback: '恢复',
    rollbackThisVersion: '恢复此版本',
    noVersions: '暂无历史版本，保存报告后将自动归档',
    versionCompareTitle: '版本对比 · {versionId} ↔ 当前编辑',
    versionCompare: '版本对比',
    compareRender: '渲染对比',
    compareDiff: '源码差异',
    compareHistoryOnly: '仅历史版本',
    diffRemoved: '−{count} 行',
    diffAdded: '+{count} 行',
    diffSame: '{count} 行未变',
    historyVersion: '历史版本 {versionId}',
    currentEdit: '当前编辑',
    hasUnsavedEdits: '含未保存修改',
    close: '关闭',
    rollbackToVersion: '恢复到此版本',
    kbFilesDialogTitle: '从知识库选择文件',
    kbFolderPlaceholder: '选择知识库文件夹',
    filterByFileName: '按文件名筛选',
    kbFilesHint: '仅支持已关联 files 记录且可抽取正文（PDF/Word/Excel/PPT/文本等）；外链引用与纯报告归档项不可用。',
    cloudFilesDialogTitle: '从云盘选择文件',
    fusionWriteTitle: '将融合检索写入报告',
    fusionWriteHint: '将把融合去重后的 Markdown 块插入所选章节（不经过 LLM 回合，可直接保存）。',
    targetSection: '目标章节',
    targetSectionPlaceholder: '选择或输入标题关键词',
    insertPosition: '插入位置',
    afterSection: '章节末尾',
    afterTitle: '标题行后',
    appendEnd: '全文末尾',
    write: '写入',
    paneBoth: '双栏',
    paneChat: '对话',
    paneEditor: '报告',
    paneBothTip: '对话与报告并排显示',
    paneChatTip: '仅显示智能助手',
    paneEditorTip: '仅显示报告编辑区',
    reportEditor: '报告编辑',
    scopeStandard: '推荐',
    scopeDocumentOnly: '仅改正文',
    scopeFull: '全量',
    advancedModel: '模型',
    advancedScope: '范围',
    advancedBodyAttach: '正文附件',
    advancedTargetChapters: '目标章节',
    advancedImages: '插图',
    selectionPreviewSuffix: '…（共 {count} 字）',
    saveTypeRollback: '回滚版本',
    saveTypeManual: '手动保存',
    saveTypeAutosave: '自动保存',
    saveTypeHallucinationFix: '幻觉修复',
    saveTypeBaseline: '生成初稿',
    saveTypeUnknown: '未知',
    restoreBaselineDraft: '恢复生成初稿',
    restoreBaselineEarliest: '恢复最早归档',
    restoreBaselineConfirmDraft: '确定要恢复到报告生成初稿吗？当前未保存的修改将会丢失。',
    restoreBaselineConfirmEarliest: '该报告无生成初稿快照，将恢复到最早归档版本（{versionId}）。当前未保存的修改将会丢失，且内容可能并非原始生成稿。',
    baselineTagDraft: '生成初稿',
    baselineTagEarliest: '最早归档',
    kbStatusIndexed: '已入库',
    kbStatusFailed: '失败',
    saveReasonStreaming: '正在生成中，完成或停止后才能保存。',
    saveReasonSaving: '正在保存，请稍候。',
    saveReasonExporting: '正在导出，请稍候。',
    saveReasonTooShort: '报告正文过短，至少需要 50 个字符。',
    saveReasonSynced: '当前内容已同步，无需保存。',
    loadTaskFailed: '加载任务失败',
    noMarkdownReport: '暂无可编辑的 Markdown 报告，请确认报告已生成',
    loadMarkdownFailed: '载入 Markdown 失败',
    downloadFailed: '下载失败 {status}',
    msg: {
      chatSyncedFromOtherWindow: '检测到其他窗口更新了对话，已同步本机记录',
      fusionWritten: '融合内容已写入报告，请核对后保存',
      writeFailed: '写入失败',
      copied: '已复制到剪贴板',
      copyFailed: '复制失败',
      maxCustomCommands: '最多保存 {max} 条自定义指令',
      customCommandSaved: '已保存修改',
      customCommandAdded: '已添加自定义指令',
      deleteCustomCommand: '删除自定义指令「{label}」？',
      confirmDelete: '确认删除',
      quickCommandFilled: '已填入「{label}」指令，按 {shortcut} 或点「发送指令」执行',
      attachmentAdded: '已添加正文附件；可选目标章节后发送，或点快捷指令「按附件改报告」',
      unsavedLeaveConfirm: '有未保存的修改，确定返回？',
      hint: '提示',
      formatFixUnavailable: '格式自动修复不可用，已使用当前正文继续操作',
      traceCopiedAll: '已复制 {count} 条 trace 为 Markdown',
      traceCopiedOne: '已复制单条 trace 为 Markdown',
      clearChatConfirm: '确定清空当前靶点的本机对话记录吗？此操作不可恢复。',
      clearChatTitle: '清空对话',
      undoSuccess: '已恢复本轮改写前的正文',
      redoSuccess: '已重做 AI 改写',
      noImagesToEmbed: '没有可嵌入的图片',
      imagesInserted: '已在光标处插入 {count} 张图片',
      insertImageFailed: '插入图片失败',
      inserted: '已插入：{name}',
      maxImages: '最多引用 {max} 张插图',
      imageAdded: '已添加插图：{name}',
      maxFiles: '最多引用 {max} 个文件',
      fileAdded: '已添加：{name}',
      uploadFailed: '上传失败',
      loadTaskFilesFailed: '加载任务文件失败',
      loadCloudFilesFailed: '加载云盘文件失败',
      loadKbListFailed: '加载知识库列表失败',
      loadKbFilesFailed: '加载知识库文件失败',
      kbFilesAdded: '已添加 {count} 个知识库文件',
      kbFilesSkipped: '{count} 个文档无可用 file_id，无法作为附件注入',
      contentTooShort: '报告内容过短（至少 50 字符）',
      interactiveEditFailed: '交互编辑失败',
      requestFailed: '请求失败',
      versionsLoadFailed: '无法获取历史版本列表',
      versionContentLoadFailed: '无法载入历史版本内容',
      versionPreviewFailed: '历史版本预览解析失败',
      rollbackOverwriteConfirm: '恢复历史版本将覆盖当前编辑内容，未保存的修改会丢失。是否继续？',
      confirmRollback: '确认恢复',
      rollingBack: '正在恢复到 {versionId}…',
      rollbackSuccess: '已恢复到 {versionId}',
      rollbackFailed: '恢复历史版本失败',
      baselineMissing: '未找到可恢复的历史版本',
      baselineRestoreSuccessDraft: '已恢复到报告生成初稿',
      baselineRestoreSuccessEarliest: '已恢复到最早归档版本',
      savedWithFormat: '（已应用格式整理）',
      saveFailed: '保存失败',
      exportedMd: '已导出 Markdown（已走格式整理）',
      exportedWord: '已导出 Word（已走格式整理）',
      exportedPdf: '已导出 PDF（已走格式整理）',
      exportFailed: '导出失败',
      hallucinationContextLoaded: '已载入幻觉修复上下文，可发送指令并多轮追问；修改后请保存并导出。',
      leaveAnyway: '仍要返回',
      stayOnPage: '留在本页',
      taskImagesAdded: '已添加 {count} 张任务图片',
      taskFilesAdded: '已添加 {count} 个任务文件',
      cloudImagesAdded: '已添加 {count} 张云盘图片',
      cloudFilesAdded: '已添加 {count} 个云盘文件',
      clearChatConfirmBtn: '清空'
    },
    quickCmd: {
      terminology: { label: '术语与错字' },
      compressSummary: { label: '压缩摘要' },
      clinicalTrials: { label: '文内临床试验' },
      headingLevels: { label: '标题层级' },
      tablesLists: { label: '表格与列表' },
      citationsHallucination: { label: '引用与幻觉排查' },
      keyDataCheck: { label: '关键数据核对' },
      executiveSummary: { label: '执行摘要' },
      expandDepth: { label: '扩展深度段落' },
      editByAttachment: { label: '按附件改报告' }
    },
    time: {
      yesterday: '昨天 {time}',
      daysAgo: '{days} 天前 {time}'
    }
  },
  userManual: {
    title: '使用手册',
    searchPlaceholder: '搜索章节标题或关键词…',
    noResults: '未找到相关内容',
    expandSidebar: '展开使用手册目录',
    collapseSidebar: '收起使用手册目录',
    searchFound: '找到 {count} 个相关章节',
    searchNotFound: '未找到匹配章节，可换个关键词试试',
    bodySearchFound: '正文匹配 {count} 处',
    adminSection: '管理后台',
    adminTag: '管理',
    navAria: '使用手册章节导航',
    nav: {
      overview: '系统概述',
      quickstart: '快速开始',
      'target-analysis': '调研任务',
      'quick-tools': '快速工具',
      report: '报告查看与下载',
      'interactive-edit': '交互式编辑',
      'intelligence-subscription': '靶点情报订阅',
      hallucination: '幻觉检测',
      chat: '报告对话',
      'knowledge-map': '知识地图',
      'knowledge-base': '知识库',
      account: '账户、用量与充值',
      membership: '会员中心',
      personal: '个人信息与设置',
      'preference-center': '偏好画像',
      feedback: '反馈与联系',
      faq: '常见问题'
    },
    searchHelp: {
      overview: '简介 产品 overview epiXora 调研分析 智能调研',
      quickstart: '注册 登录 新手 navigation sidebar',
      'target-analysis': '任务 新建对话 模板 三种调研模式 快速模式 专家模式 撰写模式 附件 模型 语音 大纲 task new chat modes',
      'quick-tools': '批量调研 模板 多主题 CSV Excel 溯源 历史 batch template export',
      report: '预览 pdf word 导出 markdown html 重新生成 满意度 preview download export',
      'interactive-edit': '交互编辑 在线 智能助手 全屏 interactive edit fullscreen AI',
      'intelligence-subscription': '情报 飞书 邮件 巡检 更新 推送 intelligence subscription feishu email',
      hallucination: '事实 校验 高亮 历史 批量 hallucination fact check verify',
      chat: '问答 对话历史 report chat Q&A conversation',
      'knowledge-map': '知识地图 wiki 脑图 大纲 3D 订阅 体检 自愈 knowledge map mind map',
      'knowledge-base': 'rag 文档 上传 本地上传 链接 knowledge base upload documents',
      account: 'xcoin 余额 充值 token 消耗 邀请 balance recharge usage',
      membership: '会员 升级 权益 模型 下载格式 membership tier upgrade',
      personal: '头像 通知 语言 统计 profile settings language',
      'preference-center': '偏好画像 记忆 专业水平 术语 preference profile memory',
      feedback: '客服 工单 bug feature feedback contact',
      faq: '帮助 常见问题 FAQ help questions'
    },
    adminNav: {
      'admin-user': '用户与租户管理',
      'admin-task': '任务管理与监控',
      'admin-finance': '财务与充值管理',
      'admin-marketing': '营销与邀请管理',
      'admin-operation': '运营与内容管理',
      'admin-system': '系统配置',
      'admin-agent': '智能体管理',
      'admin-faq': '管理员常见问题'
    },
    adminSearchHelp: {
      'admin-user': '用户 租户 users tenants',
      'admin-task': 'celery flower 任务监控 worker',
      'admin-finance': '充值 支付 xcoin 交易 会员 finance recharge',
      'admin-marketing': '邀请码 奖励 邀请审核 marketing invite',
      'admin-operation': '反馈 审核 通知 报告评价 operation content',
      'admin-system': '模型 权限 环境配置 系统巡检 system config',
      'admin-agent': 'agent studio langgraph prompt 智能体',
      'admin-faq': '运维 管理员 admin FAQ'
    },
    sectionAnchor: '定位到本节',
    navEmpty: '暂无匹配结果',
    keywordLabel: '当前关键词：',
    contentAria: '使用手册正文',
    backToTop: '回到使用手册顶部',
    backToTopTitle: '回到顶部',
    headerBadge: '使用手册',
    productTitle: 'epiXora',
    subtitle: '帮助您快速上手并高效使用三种调研模式、快速工具、报告生成、知识地图、偏好画像与管理后台等功能',
    quickResearchKicker: '调研入口',
    quickResearchTitle: '三种调研模式',
    quickResearchDesc: '快速 / 专家 / 撰写',
    quickToolsKicker: '效率工具',
    quickToolsTitle: '批量主题调研',
    quickToolsDesc: '模板、表格、导出',
    knowledgeKicker: '知识沉淀',
    knowledgeTitle: '知识地图',
    knowledgeDesc: 'Wiki、脑图、3D 图',
    quickLinksAria: '常用章节快捷入口',
    sectionJumpsAria: '章节快捷跳转'
  },
  quickToolsCitation: {
    title: '溯源文献',
    quote: '引用语句',
    source: '来源信息',
    context: '上下文',
    links: '相关链接'
  },
  common: {
    defaultUser: '用户'
  }
}
